import ConnectionEstablishedBanner from './ConnectionEstablishedBanner';
import ConnectionLostBanner from './ConnectionLostBanner';

export default {
  ConnectionEstablishedBanner,
  ConnectionLostBanner,
};
